import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import InstructionHint from '@/components/ui/InstructionHint';
import MultiTextInput from '@/components/ui/MultiTextInput';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BEFORE_ACCIDENT_REPAIRED_NAME_COMPLEMENTARY =
  'repairs_before_accident_list_complementary';

export const InputBeforeAccidentRepairedComplementary = ({
  name = BEFORE_ACCIDENT_REPAIRED_NAME_COMPLEMENTARY,
}: {
  name?: string;
}) => {
  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby zakończyć formularz'),
        },
      }}
      defaultValue={[]}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{i18n.t('Jakie szkody zostały naprawione?')}</FormLabel>
          <InstructionHint
            title={i18n.t('Napisz coś i zatwierdź, klikając ENTER.')}
          />
          <FormControl>
            <MultiTextInput
              id={name}
              {...field}
              success={!!field.value?.length}
              data-testid="input-before-accident-repaired-complementary"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
